import {
  Column,
  Columns,
  FeedbackCapture,
  RichText,
  Stack,
  TEXT_NODES,
  enhancedTextRenderers
} from '@belong/ui-components';

import { IStandardTemplate } from './model';
import { MobileOnlyDivider } from './styles';
import { ISectionSupportArticle } from '../../model';

const templateName = 'article-template-standard';
export const TEST_ID = {
  CONTAINER: templateName,
  CONTENT: `${templateName}__content`,
  FEEDBACK: `${templateName}__feedback`,
  RELATED: `${templateName}__related`,
  POPULAR: `${templateName}__popular`
};

const StandardArticleTemplate: React.FunctionComponent<ISectionSupportArticle & IStandardTemplate> = ({
  content,
  template
}) => (
  <Columns data-testid={TEST_ID.CONTAINER} space={{ lg: 'xlarge' }} collapseBelow="lg">
    <Column width="5/6">
      <Stack space={{ xs: 'xsmall', md: 'medium', lg: 'large' }}>
        <RichText
          data-testid={TEST_ID.CONTENT}
          html={content}
          renderNode={enhancedTextRenderers}
          contentLength="long"
          h2={TEXT_NODES.headingMedium}
          h3={TEXT_NODES.headingSmall}
          h4={TEXT_NODES.headingXSmall}
          h5={TEXT_NODES.copyLarge}
          h6={TEXT_NODES.copyMedium}
        />
        <FeedbackCapture data-testid={TEST_ID.FEEDBACK} {...template.feedbackCapture} />
      </Stack>
      <MobileOnlyDivider />
    </Column>
  </Columns>
);

export default StandardArticleTemplate;
